module.exports = __webpack_public_path__ + "img/badge-myelogramme-01.6b96c3f8.png";